// components/Sidebar.js
import React from 'react';
import { Link } from 'react-router-dom';
import { List, ListItem, ListItemText } from '@mui/material';
import { FaTachometerAlt, FaUsers, FaCogs } from 'react-icons/fa';

const Sidebar = () => {
  return (
    <div style={{ width: 240, height: '100vh', backgroundColor: '#333', color: '#fff' }}>
      <List>
        <ListItem button component={Link} to="/">
          <FaTachometerAlt style={{ marginRight: '10px' }} />
          <ListItemText primary="Dashboard" />
        </ListItem>
        <ListItem button component={Link} to="/users">
          <FaUsers style={{ marginRight: '10px' }} />
          <ListItemText primary="Users" />
        </ListItem>
        <ListItem button component={Link} to="/settings">
          <FaCogs style={{ marginRight: '10px' }} />
          <ListItemText primary="Settings" />
        </ListItem>
      </List>
    </div>
  );
};

export default Sidebar;
